<template>
  <section class="modal">
    <b-modal ref="my-modal" hide-footer title="">
      <!--<b-modal ref="my-modal" hide-footer title=""
    id="modal1" @shown="shown" no-fade class="hidden" @ok="hidden" @cancel="hidden">-->
      <div class="d-block text-center">
        <h3>You {{ result }}! Do you want to play again?</h3>
      </div>
      <b-button
        class="mt-3"
        variant="outline-success"
        block
        @click="this.$parent.gameEasy"
        >Start Game (Easy)</b-button
      >
      <b-button
        class="mt-2"
        variant="outline-warning"
        block
        @click="this.$parent.gameNormal"
        >Start Game (Normal)</b-button
      >
      <b-button
        class="mt-2"
        variant="outline-danger"
        block
        @click="this.$parent.gameHard"
        >Start Game (Hard)</b-button
      >
      <b-button class="mt-2" variant="" block @click="this.$parent.giveUp"
        >Stop Playing</b-button
      >
    </b-modal>
  </section>
</template>

<script>
export default {
  methods: {
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    /*shown: function(){
      let modal = document.getElementById('modal1');
      modal.parentElement.parentElement.classList.remove('hidden');
      modal.classList.add('slideInLeft');
      modal.classList.add('animated');
    },
    hidden: function(evt) {
     let modal = document.getElementById('modal1');
     evt.preventDefault();
     modal.classList.add('slideOutLeft');
      setTimeout(() => {
        this.$refs["my-modal"].hide();
        modal.parentElement.parentElement.classList.add('hidden');
        console.log('test');
      }, 1000)
    }*/
  },
  created: function () {
    this.$emit("passRef", this.$refs);
  },
  props: ["result"],
};
</script>

<style lang="scss">
.hidden {
  display: none;
}
</style>
